/**
 * text input field.
 * https://kpmg-au-ddx.atlassian.net/browse/KED-1696
 */
import {Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit} from "@angular/core";
import {UntypedFormControl, Validators} from "@angular/forms";
import {Answer} from "../../../../swaggerServices";
import {IAnswer, IFormField} from "../form-field-wrapper/form-field-wrapper.component";

@Component({
    selector: "app-text-field",
    templateUrl: "./text-field.component.html",
    styleUrls: ["./text-field.component.scss"],
    standalone: false
})
export class TextFieldComponent implements OnInit, AfterViewInit {
  @Input() question: IFormField;
  @Input() myFormControl: UntypedFormControl;
  @Input() disabled?: boolean;
  @Input() autofocus = false;
  @Input() tabIndex?: number = 0;
  @Output() answer: [Answer];
  @Output() blur: EventEmitter<any> = new EventEmitter();
  isFocused: boolean; // whether input is in focus

  @ViewChild('inputEl') inputEl: ElementRef;
  constructor() {
  }

  ngOnInit() {
  }
  ngAfterViewInit() {
    if (this.autofocus) {
      this.inputEl.nativeElement.focus();
    }
  }

  onBlur() {
    this.isFocused = false;
    this.blur.emit();
  }

}


const textFieldValidators = (q: IFormField) => {
  const validators = [];
  if (q.mandatory) validators.push(Validators.required);
  if (q.minLength) validators.push(Validators.minLength(q.minLength));
  if (q.maxLength) validators.push(Validators.maxLength(q.maxLength));
  return validators;
};

export const makeTextFieldFormControl = (q: IFormField, answer?: IAnswer) => {
  const formControlValue = answer ? answer.answer : (q.default != null ? String(q.default) : "");
  q.validators = textFieldValidators(q);
  const formControl = new UntypedFormControl(formControlValue, {validators: Validators.compose(q.validators)});
  if (!answer && formControlValue) {
    formControl.markAsDirty();
  }
  return formControl;
};
